module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAA4BAMAAABJf2bZAAAAHlBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAC3KG9qAAAACXRSTlMAEM+AX98gMO848C8fAAAAU0lEQVQ4y2OgH2BUwSEhNNMBuwbNmVNwaJiJXUsqUAKrFrbIUS3DXkslUGI61nQElDDAkY4mj2oYPhoYKnBoYGDvhGrA1ALVgKmlmQEHEGCgGAAA8ppvCF6828UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/005.png
// module id = DmEQ
// module chunks = 1